import type { Partner } from '../types.ts';

const ICON_URL = new URL('/icons/spezzial-marker.svg', import.meta.url).href;
const ICON_SIZE = { w: 36, h: 42 };

export function createMarker(
  map: google.maps.Map,
  partner: Partner,
  onClick: (p: Partner) => void,
): google.maps.Marker {
  const marker = new google.maps.Marker({
    map,
    position: partner.position,
    title: partner.name,
    icon: {
      url: ICON_URL,
      scaledSize: new google.maps.Size(ICON_SIZE.w, ICON_SIZE.h),
      anchor: new google.maps.Point(ICON_SIZE.w / 2, ICON_SIZE.h),
    },
    optimized: false,
  });
  marker.addListener('click', () => onClick(partner));
  return marker;
}
